module.exports = __webpack_public_path__ + "img/nvemp.2827469e.jpg";